import React from 'react'

import MailchimpSubscribe from "react-mailchimp-subscribe"

const url = "https://ruhlisticdecor.us7.list-manage.com/subscribe/post?u=776e2ae60158b94cc5633aa61&amp;id=1116648bbd"

// simplest form (only email)
const SimpleForm = () => <MailchimpSubscribe url={url} />

export default function MailChimpComp() {
    return (
        <MailchimpSubscribe
            url={url}
            render={({ subscribe, status, message }) => (
                <div className="mailchimp-form">
                    <SimpleForm onSubmitted={formData => subscribe(formData)} />
                    {
                        (status === "sending") && (
                            <div style={{
                                color: "#fff",
                                backgroundColor: '#efefef',
                                padding: "4px 10px",
                                marginBottom: 5,
                                borderRadius: 3,
                                fontWeight: 600
                            }}>sending...</div>
                        )
                    }
                    {
                        (status === "error") && (
                            <div style={{
                                color: "red",
                                backgroundColor: '#efefef',
                                padding: "4px 10px",
                                marginBottom: 5,
                                borderRadius: 3,
                                fontWeight: 600
                            }} dangerouslySetInnerHTML={{ __html: message }} />
                        )
                    }
                    {
                        (status === "success") && (
                            <div style={{
                                color: "green",
                                backgroundColor: '#efefef',
                                padding: "4px 10px",
                                marginBottom: 5,
                                borderRadius: 3,
                                fontWeight: 600
                            }}>Subscribed !</div>
                        )
                    }
                </div>
            )} />
    )
}
